/* UPGRADE CORE - entrance reveal + header scroll state. ~600 B, defer.
   Gate: snippets/upgrade-head.liquid adds html.ug-js inline before paint.
   Reduced motion or no IntersectionObserver -> html.ug-no-reveal, all visible.
   Guarded so the tag can appear more than once per page (the head snippet
   is rendered by every section) and still run exactly once. */
(function () {
  if (window.__ugCore) return;
  window.__ugCore = true;
  var d = document.documentElement;

  // upgrade-vsnew.css carries the "vs brand new" saving block used by the
  // catalogue and product page. Loaded here, from our own script's URL, so it
  // ships without editing a Liquid file that other passes may be rewriting.
  // 2.0: upgrade-motion.css is no longer injected here. It is <link>ed in the
  // head (snippets/upgrade-head.liquid) so it is there before first paint and
  // before the new page's first render (@view-transition needs that).
  (function loadOurSheets() {
    var me = document.querySelector('script[src*="upgrade-core.js"]');
    if (!me) return;
    ['upgrade-vsnew.css', 'upgrade-instalments.css'].forEach(function (file) {
      if (document.querySelector('link[href*="' + file + '"]')) return;
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      // 2.0: prefer the file's own versioned URL (window.UgAssetUrls, set in upgrade-head) so an
      // edit to the sheet busts the CDN cache; deriving it from this script's src reused core's ?v=.
      link.href = (window.UgAssetUrls && window.UgAssetUrls[file]) || me.getAttribute('src').replace(/upgrade-core\.js/, file);
      document.head.appendChild(link);
    });
  })();
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    d.classList.add('ug-no-reveal');
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    document.querySelectorAll('.ug-reveal').forEach(function (el) { io.observe(el); });
  }
  // REMOVED 29 Sep 2026 (F5, LOG-027 "Obsidian" foundation task). The
  // pointer-tilt handler stood here, keyed on [data-ug-tilt]/[data-ug-tilt-el]
  // in the old hero. The Obsidian hero (upgrade-hero.css, stream H) has no
  // such hooks: the direction's one entrance is a transform-only settle on
  // load, then nothing moves -- "depth comes from light, shadow and
  // reflection, not motion" (design brief). A pointer-driven tilt is the
  // opposite instinct, so it is deleted rather than left dead: dead code
  // that still queries the DOM on every page load is not free, and a stray
  // [data-ug-tilt] left on some other page would have silently reactivated
  // it. If a future direction wants pointer parallax back, this is the
  // history to start from (git blame / the design-round archive), not a
  // flag to flip.

  var h = document.querySelector('[data-ug-header]'), t = false;
  function s() { if (h) h.classList.toggle('is-scrolled', scrollY > 8); t = false; }
  addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(s); } }, { passive: true });
  s();
})();
